import { usePicture } from "@brickme/frontend-common/src/picture-edit/picture-edit-context.tsx";
import {
	availableDetailValues,
	findClosestDetailFilterValueIndex,
} from "@brickme/project-core/src/model/detail-filter.ts";
import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";
import ConfirmSheet from "~/components/sheet/confirm-sheet.tsx";
import type { ConfirmSheetProps } from "~/components/sheet/confirm-sheet.tsx";
import SliderInput from "~/components/slider-input.tsx";
import classes from "./detail-sheet.module.css";

function DetailSheet(
	props: Pick<ConfirmSheetProps, "open" | "onDone" | "onCancel">,
) {
	const t = useTranslator();
	const { picture, patchPictureDebounced } = usePicture();

	return (
		<ConfirmSheet title={t("Detail")} {...props}>
			<form className={classes["form"]} onSubmit={(e) => e.preventDefault()}>
				<SliderInput
					min={0}
					max={availableDetailValues.length}
					step={1}
					value={
						picture.detailFilter
							? findClosestDetailFilterValueIndex(picture.detailFilter) + 1
							: 0
					}
					onChange={(newValue) => {
						patchPictureDebounced({
							detailFilter:
								newValue === 0
									? undefined
									: availableDetailValues[newValue - 1],
						});
					}}
				/>
			</form>
		</ConfirmSheet>
	);
}

export default DetailSheet;
